var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51,
    fill: "none",
    viewBox: "0 0 50 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M14.007 30.416C10.7211 25.9837 8 21.9005 8 16.812C8 7.56708 15.5823 0.0426053 24.9183 0H24.9998C34.3732 0 42 7.54253 42 16.812C42 21.9005 39.2789 25.9846 35.993 30.416C35.993 30.416 25.4437 43.8985 25.0143 44.4792L14.007 30.416ZM24.9998 4.26794C31.9934 4.26794 37.6844 9.89462 37.6844 16.812C37.6844 23.7284 31.9934 29.3551 24.9998 29.3551C18.0061 29.3551 12.3156 23.7284 12.3156 16.812C12.3156 9.89462 18.0061 4.26794 24.9998 4.26794ZM19.3156 16.7682C19.3156 19.8011 21.7831 22.2679 24.8155 22.2679C27.8481 22.2679 30.3156 19.8011 30.3156 16.7682C30.3156 13.7357 27.8481 11.2679 24.8155 11.2679C21.7831 11.2679 19.3156 13.7357 19.3156 16.7682Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.51611 50.6977L9.6837 42.2964H21.0033L25.0311 47.789C25.0311 47.789 28.3974 43.3593 29.1707 42.2964H40.4596L43.6266 50.6977H6.51611Z",
    clipRule: "evenodd",
    opacity: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.edbaae094be9687cb314b98a7884c58f.svg";
export { ForwardRef as ReactComponent };